
<template>
    <div class="d-flex">
        <CCol sm="3" class="side-bar p-0 pr-4">
            <Sidebar
                ref="sidebar"
                style="height: calc(100vh - 56px); overflow-y: scroll"
                @updateChartData="updateChartDataHandler"
                @updateSpinner="(newSpinnerVal) => (spinner = newSpinnerVal)"
                :offset="offsetForFetchingData"
                @resetFilter="resetFilter"
            />
        </CCol>
        <CCol
            sm="9"
            class="px-2"
            style="height: calc(100vh - 56px); overflow-y: scroll"
        >
            <div class="d-flex justify-content-between my-3 align-items-center">
                <div class="d-flex">
                    <div class="rounded-lg py-2 m-auto ml-2">
                        <CDropdown
                            color="secondary"
                            :togglerText="
                                statusFilter === 0
                                    ? 'Show All'
                                    : statusFilter === 1
                                    ? 'In Scope'
                                    : 'Out of Scope'
                            "
                        >
                            <CDropdownItem @click="setStatusFilter(0)"
                                >Show All</CDropdownItem
                            >
                            <CDropdownItem @click="setStatusFilter(1)"
                                >In Scope</CDropdownItem
                            >
                            <CDropdownItem @click="setStatusFilter(2)"
                                >Out of Scope</CDropdownItem
                            >
                        </CDropdown>
                    </div>
                    <CButtonGroup class="align-items-center ml-4">
                        <CButton
                            color="white"
                            size="sm"
                            :disabled="isPrevPageDisabled"
                            :class="{ selected: isPrevPageDisabled }"
                            @click="moveToPage('FIRST')"
                            class="nextButton"
                        >
                            First
                        </CButton>
                        <CButton
                            color="white"
                            size="sm"
                            :disabled="isPrevPageDisabled"
                            :class="{ selected: isPrevPageDisabled }"
                            @click="moveToPage('PREV')"
                            class="nextButton"
                        >
                            Previous</CButton
                        >
                        <small class="h6 m-0 mx-3">{{
                            `${offset + 1} - ${
                                offset + limit > totalVendorCount
                                    ? totalVendorCount
                                    : offset + limit
                            } of ${totalVendorCount}`
                        }}</small
                        ><br />
                        <CButton
                            color="white"
                            size="sm"
                            :disabled="isNextPageDisabled"
                            :class="{ selected: isNextPageDisabled }"
                            @click="moveToPage('NEXT')"
                            class="nextButton"
                        >
                            Next
                        </CButton>
                        <CButton
                            color="white"
                            size="sm"
                            :disabled="isNextPageDisabled"
                            :class="{ selected: isNextPageDisabled }"
                            @click="moveToPage('LAST')"
                            class="nextButton"
                        >
                            Last
                        </CButton>
                    </CButtonGroup>
                </div>
            </div>
            <div class="d-flex spacing-2">
                <div style="width: 50%" class="pr-2">
                    <CCard>
                        <CCardHeader class="no-padding">
                            <!-- <div class="h5">Total Spend by Vendor</div> -->
                            <table style="width: 100%" class="inner-bordered">
                                <thead style="border-bottom: 1px solid #d8dbe0">
                                    <tr>
                                        <th>Total PO:</th>
                                        <th>Total Non PO:</th>
                                        <th>Current 10 Vendors AP:</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {{ totalPoSpend }}
                                        </td>
                                        <td>
                                            {{ totalNonPoSpend }}
                                        </td>
                                        <td>
                                            {{ filteredSpendsSum }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </CCardHeader>
                        <CCardBody>
                            <BarChart
                                style="height: 345px"
                                :chart-data="poChartData"
                                :key="1"
                                @on-receive="barChartClickHandler"
                            ></BarChart>
                        </CCardBody>
                    </CCard>
                </div>
                <div style="width: 50%" class="pl-2">
                    <CCard>
                        <CCardHeader>List of Vendors</CCardHeader>
                        <CCardBody>
                            <CDataTable
                                class="sticky-header-table"
                                stickyHeader
                                striped
                                :items="poTableData"
                                :fields="AP_PO_SPEND_TABLE_COLUMNS"
                                :column-filter="false"
                                :items-per-page="5"
                            >
                            </CDataTable>
                        </CCardBody>
                    </CCard>
                </div>
            </div>
            <div class="d-flex">
                <div style="width: 50%" class="pr-2">
                    <CCard>
                        <CCardHeader
                            >Contract vs Non Contract Spend by
                            Vendor</CCardHeader
                        >
                        <CCardBody>
                            <BarChart
                                style="height: 365px"
                                :chart-data="contractChartData"
                                :key="1"
                            ></BarChart>
                        </CCardBody>
                    </CCard>
                </div>
                <div style="width: 50%" class="pl-2">
                    <CCard>
                        <CCardHeader
                            >Vendors with PO Spend Higher than AP</CCardHeader
                        >
                        <CCardBody
                            style="padding-bottom: 0.25rem; padding-top: 0.5rem"
                        >
                            <CDataTable
                                class="sticky-header-table"
                                stickyHeader
                                striped
                                :items="contractTableData"
                                pagination
                                :fields="CONTRACT_SPEND_TABLE_COLUMNS"
                                :column-filter="false"
                                :items-per-page="20"
                            >
                            </CDataTable>
                        </CCardBody>
                    </CCard>
                </div>
            </div>
        </CCol>

        <CElementCover v-if="spinner" :opacity="0.8" style="z-index: 1" />
    </div>
</template>

<script>
import BarChart from "../../components/charts/Barchart";
import PieChart from "../../components/charts/PieChart";
import Sidebar from "../../components/Sidebar/sidebar";
import _ from "../Utility/utility";
import { mapState, mapMutations } from "vuex";
import { getSelectedClients } from "../../store";


export default {
    data() {
        return {
            AP_PO_SPEND_TABLE_COLUMNS: [
                {
                    key: "vendor_source",
                    _style: "min-width: 130px",
                },
                { key: "po", label: "PO" },
                { key: "ap", label: "AP" },
                {
                    key: "mapped_spend",
                    label: "Mapped Spend",
                    _style: "min-width: 80px",
                },
            ],
            CONTRACT_SPEND_TABLE_COLUMNS: [
                { key: "vendor_name" },
                { key: "ap_spend", label: "AP Spend" },
                { key: "po_spend", label: "PO Spend" },
            ],
            PO_CHART_DATASET_CONFIGS: [
                {
                    key: "po_spend",
                    label: "PO",
                    barColor: "#2f5233",
                },
                {
                    key: "non_po_spend",
                    label: "Non PO",
                    barColor: "#94c973",
                },
            ],
            CONTRACT_CHART_DATASET_CONFIGS: [
                {
                    key: "contract_spend",
                    label: "Contract",
                    barColor: "#2f5233",
                },
                {
                    key: "non_contract_spend",
                    label: "Non Contract",
                    barColor: "#94c973",
                },
            ],
            appliedFilters: {},
            offset: 0,
            offsetForFetchingData: 0,
            limit: 10,
            totalVendorCount: 0,
            totalNonPoSpend: "",
            totalPoSpend: "",
            filteredSpendsSum: "",
            order: "desc",
            poChartData: {},
            contractChartData: {},
            isNextPageDisabled: false,
            isPrevPageDisabled: true,
            poTableData: [],
            contractTableData: [],
            spinner: false,
        };
    },
    components: {
        Sidebar,
        BarChart,
        PieChart,
    },
    computed: {
        ...mapState(["statusFilter"]),
        selectedClients() {
            return getSelectedClients();
        },
    },
    watch: {
        selectedClients() {},
    },
    methods: {
        ...mapMutations(["setStatusFilter"]),
        ...mapMutations(["setAp_PO_Date"]),
        async moveToPage(target) {
            switch (target) {
                case "FIRST":
                    this.offset = 0;
                    this.isPrevPageDisabled = true;
                    this.isNextPageDisabled = false;
                    break;
                case "NEXT":
                    this.offset = this.offset + this.limit;
                    this.isPrevPageDisabled = false;
                    if (this.offset + this.limit >= this.totalVendorCount) {
                        this.isNextPageDisabled = true;
                    }
                    break;
                case "PREV":
                    this.offset = this.offset - this.limit;
                    this.isNextPageDisabled = false;
                    if (this.offset - this.limit < 0) {
                        this.isPrevPageDisabled = true;
                    }
                    break;
                case "LAST":
                    const residue = this.totalVendorCount % this.limit;
                    this.offset = this.totalVendorCount - residue;
                    this.isNextPageDisabled = true;
                    this.isPrevPageDisabled = false;
                    break;
                default:
                    break;
            }
            this.offsetForFetchingData = this.offset;
        },
        getBarChartData(rawData, chartConfigs) {
            return {
                datasets: chartConfigs.map((config) => ({
                    data: rawData[config.key],
                    backgroundColor: config.barColor,
                    label: config.label,
                })),
                labels: rawData.xAxisLabels,
                tooltipLabels: rawData.xAxisLabels,
            };
        },
        updateChartDataHandler(chartData, resetPagination) {
            let result = chartData.spendmd_db_spend_by_vendor_mapped_aggregate;
            if (result) {
                this.totalVendorCount = result.aggregate.max.vendor_count;

                if (this.offset + this.limit >= this.totalVendorCount) {
                    this.isNextPageDisabled = true;
                } else {
                    this.isNextPageDisabled = false;
                }
                const tempChartData = {};

                this.PO_CHART_DATASET_CONFIGS.forEach((config) => {
                    tempChartData[config.key] = [];
                });
                tempChartData.xAxisLabels = [];
                tempChartData.vendorIds = [];
                const tempPoTableData = [];
                this.totalNonPoSpend = result.aggregate.max.total_non_po_spend;
                this.totalPoSpend = result.aggregate.max.total_po_spend;

                this.setAp_PO_Date({
                    ap_start: result.aggregate.max.ap_start,
                    ap_end: result.aggregate.max.ap_end,
                    po_start: result.aggregate.max.po_start,
                    po_end: result.aggregate.max.po_end,
                    ap_note: result.aggregate.max.ap_note,
                    po_note: result.aggregate.max.po_note,
                });
                result.nodes.forEach((el) => {
                    this.PO_CHART_DATASET_CONFIGS.forEach((config) => {
                        tempChartData[config.key].push(
                            _.parseAmountToInt(el[config.key])
                        );
                    });
                    tempChartData.xAxisLabels.push(el.vendor_source);
                    tempChartData.vendorIds.push(el.vendor_id);
                    tempPoTableData.push({
                        vendor_source: el.vendor_source,
                        po: _.getMoneyFormat(_.parseAmountToInt(el.po_spend)),
                        ap: _.getMoneyFormat(
                            _.parseAmountToInt(el.po_spend) +
                                _.parseAmountToInt(el.non_po_spend)
                        ),
                        mapped_spend: _.getMoneyFormat(
                            _.parseAmountToInt(el.mapped_spend)
                        ),
                    });
                });

                this.poChartData = this.getBarChartData(
                    tempChartData,
                    this.PO_CHART_DATASET_CONFIGS
                );
                this.poTableData = tempPoTableData;
                this.filteredSpendsSum = _.getMoneyFormat(
                    _.parseAmountToInt(result.aggregate.sum.po_spend) +
                        _.parseAmountToInt(result.aggregate.sum.non_po_spend)
                );
            }

            result = chartData.spendmd_db_contract_spend_by_vendor_aggregate;
            if (result) {
                const tempChartData = {};

                this.CONTRACT_CHART_DATASET_CONFIGS.forEach((config) => {
                    tempChartData[config.key] = [];
                });
                tempChartData.xAxisLabels = [];
                tempChartData.vendorIds = [];

                result.nodes.forEach((el) => {
                    this.CONTRACT_CHART_DATASET_CONFIGS.forEach((config) => {
                        tempChartData[config.key].push(
                            _.parseAmountToInt(el[config.key])
                        );
                    });
                    tempChartData.xAxisLabels.push(el.vendor_source);
                    tempChartData.vendorIds.push(el.vendor_id);
                });

                this.contractChartData = this.getBarChartData(
                    tempChartData,
                    this.CONTRACT_CHART_DATASET_CONFIGS
                );
            }

            result = chartData.spendmd_db_po_spend_above_ap_aggregate;
            if (result) {
                const tempContractTableData = [];
                result.nodes.forEach((el) => {
                    tempContractTableData.push({
                        vendor_name: el.vendor_source,
                        po_spend: el.po_spend,
                        ap_spend: el.ap_spend,
                    });
                });

                this.contractTableData = tempContractTableData;
            }

            if (resetPagination) {
                this.offset = 0;
                this.isPrevPageDisabled = true;
                this.isNextPageDisabled = false;
            }
        },
        resetFilter() {
            this.moveToPage("FIRST");
            this.$refs.sidebar.fetchData();
        },

        barChartClickHandler(event) {},
    },
    mounted() {},
};
</script>

<style scoped>
.nextButton {
    padding: 15px 25px;
    margin: auto 2px;
    background-color: white !important;
    color: #1f2621 !important;
}

.selected-value {
    margin-bottom: 0;
}

.selected-value span {
    margin-right: 2%;
    color: blue;
    margin-bottom: 0;
}

.callout[data-v-7adad98b] {
    height: 4rem;
}

.callout {
    background-color: white;
    height: 4rem;
}

.setPadding {
    /* padding-bottom: 20px; */
    padding: 10px !important;
}

.c-callout {
    margin: 0.5rem 0;
}

.selected {
    background-color: #9ca8a9 !important;
    color: #ffffff !important;
}

.sticky-header-table::v-deep > div {
    height: 365px;
    overflow-y: auto;
    position: inherit;
}

.sticky-header-table::v-deep table {
    margin-bottom: 0;
}

.sticky-header-table::v-deep table > thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: white;
}

.sticky-header-table::v-deep table > thead > tr > th {
    padding: 0;
    border: none;
    border-bottom: 2px solid;
    border-bottom-color: #d8dbe0;
}

.sticky-header-table::v-deep table > thead > tr > th > div {
    padding: 12px;
    background-color: white;
}

.sticky-header-table::v-deep table > thead > tr > th > div.column-filter {
    padding: 8px 0;
    border-bottom: none;
}

.inner-bordered {
    width: 100%;
}

.inner-bordered > thead {
    border-bottom: 1px solid #d8dbe0;
}

.inner-bordered th,
.inner-bordered td {
    border-right: 1px solid #d8dbe0;
    padding: 6px 4px;
    text-align: center;
}

.inner-bordered th:last-child,
.inner-bordered td:last-child {
    border-right: none;
}

.no-padding {
    padding: 0;
}
</style>
